const SvgAuthFacebook = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_13217_5867)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 12C2.5 6.477 6.977 2 12.5 2C18.023 2 22.5 6.477 22.5 12C22.5 17.523 18.023 22 12.5 22C12.9605 22 13.41 21.958 13.8535 21.898V14.6505H16.4415L16.848 12.0215H13.8535V10.5845C13.8535 9.49249 14.2105 8.52399 15.232 8.52399H16.8735V6.22999L16.8598 6.22814C16.5659 6.18837 15.9571 6.10599 14.8225 6.10599C12.4155 6.10599 11.0045 7.37699 11.0045 10.273V12.022H8.53V14.651H11.004V21.877C11.494 21.95 11.9905 22 12.5 22C6.977 22 2.5 17.523 2.5 12Z"
          fill="#0E8CF1"
        />
      </g>
      <defs>
        <clipPath id="clip0_13217_5867">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgAuthFacebook;
